import {Component, OnInit, Input, OnChanges, SimpleChange, SimpleChanges, ViewChild} from '@angular/core';
import { AttemptProviderChangeService} from '../../services/attempt-provider-change.service';
import { AttemptProviderChangeModalComponent} from '../../modals/attempt-provider-change-modal/attempt-provider-change-modal.component';
import { ModalService} from 'ngx-dynamic-modal';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';

@Component({
  selector: 'app-attempts-provider-change',
  templateUrl: './attempts-provider-change.component.html',
  styleUrls: ['./attempts-provider-change.component.scss']
})
export class AttemptsProviderChangeComponent implements OnInit,OnChanges {

    @Input() portalService;

    elements: Array<any>=[];
    temp: Array<any>=[];
    enabled:boolean;
    portal_pk:any;
    service_pk:any;
    camp_pk: any;

    tableSearchText: string;

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 10;

    @ViewChild(PaginationComponent) pagination: PaginationComponent;

    constructor(private attemptService: AttemptProviderChangeService,
                  private modal:ModalService,
                  private alerta:AlertaService) {

    }


    ngOnChanges(changes:SimpleChanges){
          let change=changes.portalService;
          if(this.portalService.getPkService()){
              this.getAttemptProviderChangeList({
                  portal_pk: this.portalService.getPkPortal(),
                  service_pk:this.portalService.getPkService(),
                  camp_pk: this.portalService.pkCamp
              })
          }
    }

    ngOnInit() {
          this.portal_pk=this.portalService.getPkPortal();
          this.service_pk=this.portalService.getPkService();
          this.camp_pk = this.portalService.pkCamp;

          this.getAttemptProviderChangeList({ portal_pk: this.portal_pk, service_pk: this.service_pk, camp_pk: this.camp_pk})

    }

    getAttemptProviderChangeList(criteria){
          this.enabled=true;
          this.attemptService.getAttemptsProvChangeList(criteria)
              .subscribe( result => {
                  this.elements= result;
                  this.temp = [...result];
                  this.endAt = (!this.haveToPaginate()) ? this.elements.length : this.perPage;
                  }, error => {
                  console.log(error);
                  this.enabled=false;
                  }, () =>{
                  this.enabled=false;
              })
    }

    openModal(element= null) {
          let params={
              portal_pk: this.portalService.getPkPortal(),
              service_pk: this.portalService.getPkService(),
              camp_pk: this.portalService.pkCamp
          };

          this.modal.addDynamicComponent(AttemptProviderChangeModalComponent, {element,params}, (res) => {

              this.ngOnInit();
                /*if (!res.edit) {
                    this.elements.unshift(res.element);
                } else {
                    let indx=this.elements.indexOf(element);
                    this.elements[indx]=res.element;
                }*/
          })

    }

    deleteElement(element) {
            this.alerta.addAlert('confirm','Do you want to Delete Failover config?')
                .then((result)=>{
                    if(result.value){
                        this.enabled=true;
                        this.attemptService.removeAttemptsProvChange(element.pk)
                            .subscribe( result => {
                            }, error => {
                                console.log(error);
                                this.enabled=false;
                            }, () => {
                                this.alerta.addAlert('success','Failover Config Deleted Succesfully!!')
                                let indx=this.elements.indexOf(element);
                                this.elements.splice(indx,1);
                                this.enabled=false
                            })
                    }
                })
    }

    goToPage(n: number) {
        this.startAt = (this.pagination) ? this.pagination.getStart() : 0;
        this.endAt = (this.pagination) ? this.pagination.getEnd() : this.perPage;

    }

    haveToPaginate(): boolean {
        return this.perPage < this.elements.length;
    }

    updateFilter(event) {
        this.tableSearchText = event.target.value.toLowerCase();
        const temp = this.temp.filter((d) => {
            return d['text'].toLowerCase().indexOf(this.tableSearchText) !== -1 || d['provider_name'].toLowerCase().indexOf(this.tableSearchText) !== -1 || !this.tableSearchText;
        });

        this.elements = temp;
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/components/attempts-provider-change/attempts-provider-change.component.ts